import { render } from "./admin-permission-set.vue?vue&type=template&id=c5606d26&scoped=true&ts=true"
import script from "./admin-permission-set.vue?vue&type=script&lang=ts"
export * from "./admin-permission-set.vue?vue&type=script&lang=ts"

import "./admin-permission-set.vue?vue&type=style&index=0&id=c5606d26&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5606d26"]])

export default __exports__